import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  otherOrganizations: [],
  allOtherOrganizations: [],
  totalPages: 0,
  totalRecords: 0,
  otherOrganization: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_57: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_OtherOrganizations(state, otherOrganizations) {
    state.otherOrganizations = otherOrganizations.items;
    state.totalPages = otherOrganizations.totalPages;
    state.totalRecords = otherOrganizations?.totalRecords ?? 0;
  },
  SET_AllOtherOrganizations(state, otherOrganizations) {
    state.allOtherOrganizations = otherOrganizations;
  },
  SET_OtherOrganization(state, otherOrganization) {
    state.otherOrganization = otherOrganization;
  },
};
const actions = {
  errorOtherOrganization({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllOtherOrganizations({ commit, dispatch, rootState }) {
    return apiClient
      .get('/OtherOrganizations/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllOtherOrganizations', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOtherOrganization', error);
      });
  },
  getOtherOrganizationsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, cityId },
  ) {
    var url =
      '/OtherOrganizations/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_OtherOrganizations', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOtherOrganization', error);
      });
  },
  addOtherOrganization({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OtherOrganizations', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOtherOrganization', error);
      });
  },
  getOtherOrganization({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/OtherOrganizations/ById?otherOrganizationId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_OtherOrganization', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOtherOrganization', error);
      });
  },
  editOtherOrganization({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/OtherOrganizations/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOtherOrganization', error);
      });
  },
  deleteOtherOrganization({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/OtherOrganizations/Remove?otherOrganizationId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorOtherOrganization', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
